import * as React from 'react'

export const HeartIcon = ({
  size = 16,
  color = '#1B3029',
  ...props
}: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size * 12) / 13}
    viewBox="0 0 13.5 12"
    fill="none"
    {...props}
  >
    <path
      d="M11.446 6.91035C10.6739 7.83887 9.56944 8.77717 8.28905 9.87185C7.859 10.2433 7.36053 10.6635 6.84251 11.1131C6.55906 11.3575 6.13878 11.3575 5.86511 11.1131C5.3471 10.6635 4.8584 10.2433 4.41857 9.87185C3.13819 8.77717 2.03373 7.83887 1.26159 6.91035C0.411258 5.87431 0.000753165 4.88714 0.000753165 3.81201C-0.0187947 2.81507 0.342841 1.84745 1.00747 1.10463C1.66232 0.391132 2.58107 -0.00959923 3.54869 0.0001747C4.27196 0.0001747 4.97569 0.244523 5.54257 0.694124C5.85534 0.938472 6.11924 1.22192 6.34404 1.54446C6.56884 1.22192 6.84251 0.938472 7.1455 0.694124C7.71239 0.244523 8.41611 0.000174551 9.14915 0.00994848C10.1168 0.000174551 11.0355 0.400906 11.6904 1.1144C12.355 1.85722 12.7166 2.82484 12.6971 3.82178C12.7069 4.88714 12.2964 5.87431 11.446 6.91035Z"
      fill={color}
    />
  </svg>
)

export default HeartIcon
